import React from 'react';

export default function WscTabButton({ active, onClick, children, isDark, theme, color }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '5px 12px', borderRadius: 6, fontSize: 12, fontWeight: 600,
        cursor: 'pointer', border: '1px solid ' + (active ? color : theme.border),
        background: active ? (color + '22') : 'transparent',
        color: active ? color : theme.textSecondary,
        transition: 'all 0.15s ease',
      }}
    >
      {children}
    </button>
  );
}
